import * as React from 'react';
import { Slider as SliderPrimitive } from '@base-ui/react/slider';

import { cn } from '@/lib/utils';

function Slider({ className, defaultValue, value, min = 0, max = 100, ...props }: SliderPrimitive.Root.Props) {
  const _values = React.useMemo(() => (Array.isArray(value) ? value : Array.isArray(defaultValue) ? defaultValue : [min, max]), [value, defaultValue, min, max]);

  return (
    <SliderPrimitive.Root className={cn('data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full', className)} data-slot='slider' defaultValue={defaultValue} value={value} min={min} max={max} thumbAlignment='edge' {...props}>
      <SliderPrimitive.Control className='data-[orientation=vertical]:min-h-40 relative flex w-full touch-none items-center select-none data-disabled:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col'>
        <SliderPrimitive.Track
          data-slot='slider-track'
          className='bg-muted rounded-full data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5 relative grow overflow-hidden select-none'
        >
          <SliderPrimitive.Indicator
            data-slot='slider-range'
            className='bg-primary/40 border-t-[3px] border-b-[3px] border-primary/80 shadow-[0_0_8px_oklch(0.78_0.1_195/0.5)] select-none data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full'
          />
        </SliderPrimitive.Track>
        {Array.from({ length: _values.length }, (_, index) => (
          <SliderPrimitive.Thumb
            data-slot='slider-thumb'
            key={index}
            className='block h-5 w-5 rounded-full border-2 border-primary-foreground bg-primary shadow-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:pointer-events-none disabled:opacity-50 cursor-pointer shrink-0 select-none'
          />
        ))}
      </SliderPrimitive.Control>
    </SliderPrimitive.Root>
  );
}

export { Slider };
